<template>
  <div class="MarketOptions">
    <div class="info">
      <i class="el-icon-warning"></i>
      <p>Option templates are for creating products with different specifications.</p>
    </div>
    <table class="table">
      <thead class="head">
      <tr>
        <th class="head_item" style="width: 190px">Option Template</th>
        <th class="head_item" style="min-width: 450px">Option Detail</th>
        <th class="head_item"></th>
      </tr>
      </thead>
      <tbody class="body">
      <template v-if="option_list.length!==0">
        <tr class="body_row" v-for="option in option_list" :key="option.template_id">
          <td class="body_item">
            {{option.template_name}}
          </td>
          <td class="body_item">
            <div class="option_list">
              <div class="option" v-for="item in option.items" :key="item.option_id">
                {{item.option_name_en}}
              </div>
            </div>

          </td>
          <td class="body_item">
            <el-button class="action" type="primary" size="mini" @click="onEdit(option.template_id)">Edit</el-button>
            <el-button class="action" type="danger" size="mini" @click="onDelete(option.template_id)">Delete</el-button>
          </td>
        </tr>
      </template>
      <template v-if="option_list.length===0&&option_list!==false">
        <tr class="body_row">
          <td class="body_item">

          </td>
          <td class="body_item no_option">
            No Option Template
          </td>
        </tr>
      </template>
      </tbody>
    </table>
    <el-button @click="dialog_visible = true" class="add" type="primary" size="medium" round="" icon="el-icon-plus">
      Create Template
    </el-button>

    <el-dialog class="dialog" width="70%" :visible.sync="dialog_visible">
      <OptionTemplate :tid="template_id" @close="onClose" v-if="dialog_visible"></OptionTemplate>
    </el-dialog>
  </div>
</template>

<script>
  import {deleteProductOption, getProductOption} from "@/utils/api";
  import OptionTemplate from "@/components/Market/OptionTemplate/OptionTemplate";

  export default {
    props: {},
    components: {
      OptionTemplate
    },
    data: () => {
      return {
        template_id: '',
        option_list: false,
        dialog_visible: false
      }
    },
    watch: {
      dialog_visible: function (n) {
        if (!n) {
          this.template_id = '';
          getProductOption().then(res => {
            this.option_list = res.option_list
          })
        }
      }
    },
    methods: {
      onClose() {
        this.dialog_visible = false;
        getProductOption().then(res => {
          this.option_list = res.option_list
        })
      },
      onEdit(template_id) {
        this.template_id = template_id;
        this.dialog_visible = true;
      },
      onDelete(template_id) {
        this.$confirm(`Are you sure to delete this option template? This won't affect products created with the template.`, 'Warning', {
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          type: 'warning'
        }).then(() => {
          this.$showLoading('Loading');
          deleteProductOption(template_id).then(res => {
            this.$hideLoading();
            if (res.errcode === 0) {
              this.$message({
                type: 'success',
                message: `Option Deleted!`
              });
              getProductOption().then(res => {
                this.option_list = res.option_list
              })
            }
          });
        }).catch(() => {
        });
      },
    },
    beforeMount() {
      getProductOption().then(res => {
        this.option_list = res.option_list
      })
    }
  };

</script>

<style lang="scss" scoped>
  @import "_MarketOptions.scss";
</style>